export enum FacebookCommerceRouteEnum {
  MAIN = "facebook-commerce.main",
}
